"use client";

import { SpecialRow } from "@/data/specials";
import { getWatchCTAButtonText } from "@punchup/data/legacy";
import { useProductsForSpecial } from "@punchup/data/hooks";
import { useSpecialUnlockedForUser } from "@/hooks/specials/useSpecialUnlockedForUser";
import { useUser } from "@punchup/data/legacy/hooks";
import { Product } from "@punchup/data/legacy";

interface WatchCTAButtonProps {
  special: SpecialRow;
  pricingPriority?: Product["category"][];
}

export function WatchCTAButton({
  special,
  pricingPriority,
}: WatchCTAButtonProps) {
  const user = useUser();

  const userId = user === undefined ? undefined : (user?.id ?? null);

  const { unlocked, isLoading: unlockLoading } = useSpecialUnlockedForUser({
    specialId: special.id,
    userId,
    special,
  });

  const { products: specialProducts, isLoading: productsLoading } =
    useProductsForSpecial(special);

  const isLoading = user === undefined || unlockLoading || productsLoading;

  const specialValue = { ...special, unlocked: isLoading ? null : unlocked };
  const products = specialProducts ?? [];

  const text = getWatchCTAButtonText({
    special: specialValue,
    products,
    pricingPriority,
  });

  return <>{text}</>;
}
